export class LocationVO {
	id: string;
	label: string;
}
